export default __webpack_public_path__ + "static/media/sa-icon.d4f539e4.svg";